var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"auth-footer"},[_c('FooterText')],1),_vm._v(" "),_c('Support')],1)}
var staticRenderFns = []

export { render, staticRenderFns }